<div class="spinner_container dark-overlay" [ngClass]="{'dark-overlay':utilService.isLoading}" *ngIf="utilService.isLoading">
    <mat-spinner style="left: 50%; top: 50%"></mat-spinner>
</div>
